<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <form name="appForm" [formGroup]="appForm" class="tax-type-form w-100-p" fxLayout="column" fxFlex>
        <mat-form-field class="w-100-p">
            <input matInput name="name" formControlName="name" mat-maxlength="50" placeholder="Nombre de la aplicación"
                autocomplete="off" required>
        </mat-form-field>
        <mat-form-field class="w-100-p">
            <input matInput name="redirectUri" formControlName="redirectUri" mat-maxlength="50"
                placeholder="Redirect URI" autocomplete="off" required>
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="end end">
            <button mat-raised-button (click)="saveApp()" class="save-button mat-accent" [disabled]="appForm.invalid"
                aria-label="Guardar">Guardar</button>
        </div>
    </form>
</wtf-dialogcontent>